import React, { useEffect, useState } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { firestore } from './FirebaseConfig';

const ContactData = () => {
  const [contactData, setContactData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(firestore, 'inquiries'));
        const data = [];
        querySnapshot.forEach((doc) => {
          data.push({ id: doc.id, ...doc.data() });
        });
        setContactData(data);
      } catch (error) {
        console.error('Error fetching contact data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this record?');
    if (confirmDelete) {
      try {
        // Fixed: Delete from 'inquiries' collection instead of 'Contact'
        await deleteDoc(doc(firestore, 'inquiries', id));
        setContactData(contactData.filter((contact) => contact.id !== id));
      } catch (error) {
        console.error('Error deleting contact data:', error);
      }
    }
  };

  // Filter data based on search term
  const filteredData = contactData.filter(contact => 
    contact.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    contact.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    contact.phone.includes(searchTerm)
  );

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12">
          <div className="card shadow-lg">
            <div className="card-header bg-danger text-white d-flex justify-content-between align-items-center">
              <h2 className="h4 mb-0">Contact Inquiries</h2>
              <div className="w-25">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search inquiries..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive" style={{ maxHeight: '70vh' }}>
                <table className="table table-hover table-striped mb-0">
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="ps-4">#</th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Message</th>
                      <th scope="col">Timestamp</th>
                      <th scope="col" className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((contact, index) => (
                        <tr key={contact.id}>
                          <td className="ps-4 fw-bold">{index + 1}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: '36px', height: '36px' }}>
                                <span className="text-white fw-bold">{contact.name.charAt(0)}</span>
                              </div>
                              <div>{contact.name}</div>
                            </div>
                          </td>
                          <td>{contact.email}</td>
                          <td>{contact.phone}</td>
                          <td>
                            <div className="text-truncate" style={{ maxWidth: '200px' }} title={contact.message}>
                              {contact.message}
                            </div>
                          </td>
                          <td>
                            {contact.timestamp ? contact.timestamp.toDate().toLocaleString() : 'N/A'}
                          </td>
                          <td className="text-center">
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDelete(contact.id)}
                            >
                              <i className="bi bi-trash"></i> Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          {contactData.length === 0 ? 'No inquiries found.' : 'No matching inquiries found.'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer bg-light d-flex justify-content-between align-items-center">
              <small className="text-muted">
                Showing {filteredData.length} of {contactData.length} inquiries
              </small>
              <small className="text-muted">
                Last updated: {new Date().toLocaleTimeString()}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactData;